import React, { useEffect, useState, useContext } from "react";
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { Helmet } from "react-helmet-async";
import { CircularProgress } from "@mui/material";
import TableCS from "../../components/TableCS";
import BotonCS from "../../components/BotonCS";
import LabelCS from "../../components/LabelCS";
import DropDownListCS from "../../components/DropDownListCS";
import Alert from "../../components/Alert";
import ModalCS from "../../components/ModalCS";
import { CONFIGURAR } from "../../tools/ApiRoutes";
import APP from "../../tools/AppRoutes";
import Context from "../Master/SessionProvider";
import enviarPeticion from "../../tools/EnviarPeticion";
import TextFieldCS from "../../components/TextFieldCS";
import { Edit, Delete } from "@mui/icons-material";
import {Tooltip} from '@mui/material';

const ConfigurarRegimenes = ({ history }) => {
    const { user } = useContext(Context);
    const [ loading, setLoading ] = useState(true);
    const [ alert , setAlert ] = useState({ msg: '', severity: 'success', open: false }); //MODAL NOTIFICACIONES
    const [ listaRegimenes, setListaRegimenes ] = useState([]);
    const [ listaRegimenesIntelisis, setListaRegimenesIntelisis] = useState([]); 
    const [ showModalEliminar, setShowModalEliminar ] = useState(false);
    const [ showModalEditar, setShowModalEditar ] = useState(false);
    const [ seleccionado, setSeleccionado ] = useState({});
    const [ editarGrid, setEditarGrid ] = useState({});
    const [ tituloModal, setTituloModal ] = useState('');

    const columnasTabla = [
        { title: "Régimen F.E.", field: "NombreRegimen" },
        { title: "Régimen Intelisis", field: "RegimenIntelisis"},
        { title: "Códigos Responsabilidades", field: "CodigosResponsabilidades" },
        { title: "Estatus", field: "Estatus", cellStyle: (cellValue) => { 
            switch (cellValue){
                case 'Inactivo':
                    return {color: 'red'}
                default:
                    return {color: 'inherit'}
            }
          } },
        { title: "Autoretenedor", render: (row) => {
            return (<>
                <input type="checkbox" checked={row.Autoretenedor} disabled={true} />
            </>)        
            }},
        { title: "RetenedorIVA", render: (row) => {
            return (<>
                <input type="checkbox" checked={row.RetenedorIVA} disabled={true} />
            </>)        
            }},
        { title: "", render: (row) => {
            return(
                <>
                    <Tooltip title='Editar' placement='top'>
                        <Edit className="hoverOptions" onClick={(event) => {editar(event, row) }}></Edit>
                    </Tooltip>
                    {/* <Tooltip title='Eliminar' placement='top'>
                        <Delete className="hoverOptions" onClick={(event) => {eliminar(event, row) }}></Delete>
                    </Tooltip> */}
                </>
            )
        }},
    ];

    //CIERRA MENSAJE DE VALIDACIÓN
    const closeAlert = () => setAlert({ msg: '', severity: 'success', open: false });

    const editar = (event, row) => {
        setTituloModal('Editar Configuración');
        setSeleccionado(row);
        setEditarGrid(row);
        setShowModalEditar(true);
    }
    
    const eliminar = async (event, row) => {
        setSeleccionado(row);
        setShowModalEliminar(true);
    }

    const cerrarModalEliminar = () => {
        setShowModalEliminar(false);
    }

    const cerrarModalEditar = () => {
        setShowModalEditar(false);
    }

    const handleEdit = (prop) => (event) => {
        let valor = event.target.value;

        //VALIDAMOS LOS CHECKS
        if (prop === "Autoretenedor"){
            valor = editarGrid.Autoretenedor === true ? false : true;
        }
        if (prop === "RetenedorIVA"){
            valor = editarGrid.RetenedorIVA === true ? false : true;
        }

        //SI SON LOS CÓDIGOS HACEMOS VALIDACIONES ADICIONALES
        if (prop === "CodigosResponsabilidades"){
            const soloNumeros = /^[0-9-]+$/.test(valor);

            //SI SON SOLO NÚMEROS Y ESPACIOS GUARDAMOS EL VALOR
            if (soloNumeros === true){
                setEditarGrid({...editarGrid, [prop]: valor})
            }
        }
        else{
            //DE LO CONTRARIO GUARDAMOS TODO LO QUE ESCRIBAN
            setEditarGrid({...editarGrid, [prop]: valor});
        }
        
    }

    const validarCodigos = () => {
        //VALIDAMOS SI YA HAY UNA CONFIGURACIÓN CON LOS MISMOS CÓDIGOS
        let bandera = true;

        listaRegimenes.forEach(element => {

            if (element.IdConfiguracion !== editarGrid.IdConfiguracion){
                if (element.CodigosResponsabilidades === editarGrid.CodigosResponsabilidades){
                    bandera = false; //SI ENCUENTRA OTRA CONFIGURACIÓN IDÉNTICA NO DEJAMOS AVANZAR
                }
            }
           
        });

        return bandera;
    }

    const formatoCodigos = (event) => {
        
        const arreglo = event.target.value.split('-'); //LOS SEPARAMOS POR ESPACIOS
        const numeros = arreglo.sort((a,b) => a - b); //LOS ORDENAMOS
        const unicos = [...new Set(numeros)]; //QUITAMOS DUPLICADOS
        let resultado = "";

        unicos.forEach(element => {
            const n = element.padStart(2,"0"); //FORMATO DOS DÍGITOS
            resultado = resultado += n + "-";
        });

        //QUITAMOS ÚLTIMO GUIION MEDIO
        const final = resultado.substring(0,resultado.length -1);
        
        setEditarGrid({...editarGrid, ["CodigosResponsabilidades"]: final});
    }

    const validacionesActualizar = async () => {

        const validar = (valor) => {
            if (valor === null || valor === undefined || valor === "") return false
            else return true;
        }

        if (validar(editarGrid.NombreRegimen) === false){
            setAlert({ msg: 'Escribe el nombre del Régimen', severity: 'warning', open: true });
            return false;
        }
        else{
            //SI EL NOMBRE NO ESTÁ VACÍO REVISAMOS QUE NO SE DUPLIQUE
            //BUSCAMOS SI EXISTE EL RÉGIMEN EN LA LISTA
            const filtro = listaRegimenes.filter(row => row.NombreRegimen === editarGrid.NombreRegimen);

            //REVISAMOS SI EL NOMBRE NO QUEDA IGUAL
            if (editarGrid.NombreRegimen !== seleccionado.NombreRegimen){

                //SI EL NOMBRE ES IGUAL Y YA SE ENCUENTRA ESE NOMBRE ES PORQUE SE DUPLICA
                if (filtro.length > 0){
                    setAlert({ msg: 'Ya existe una Configuración con ese nombre', severity: 'warning', open: true });
                    return false
                }
            }
        }

        if (validar(editarGrid.RegimenIntelisis) === false){
            setAlert({ msg: 'Elige un Régimen de Intelisis', severity: 'warning', open: true });
            return false;
        }
        else{
            if(editarGrid.RegimenIntelisis === "Selecciona una opción"){
                setAlert({ msg: 'Elige un Régimen de Intelisis', severity: 'warning', open: true });
                return false
            }
        }

        if (validar(editarGrid.CodigosResponsabilidades) === false){
            setAlert({ msg: 'Escribe los códigos que configran este Régimen', severity: 'warning', open: true });
            return false;
        }
        else{
            const res = validarCodigos();
            if (res === false){
                setAlert({ msg: 'Ya hay una Configuración con esos Códigos', severity: 'warning', open: true });
                return false;
            }
        }

        if (validar(editarGrid.Estatus) === false){
            setAlert({ msg: 'Elige un estatus para la configuración', severity: 'warning', open: true });
            return false;
        }
        else{
            if(editarGrid.Estatus === "Selecciona una opción"){
                setAlert({ msg: 'Elige un estatus para la configuración', severity: 'warning', open: true });
                return false
            }
        }

        //SI LLEGA AQUÍ REGRESAMOS TRUE
        return true;
    }

    const actualizarRegimen = async () => {

        if (await validacionesActualizar() === true){

            const data = {
                IdConfiguracion: seleccionado.IdConfiguracion ?? 0,
                NombreRegimen: editarGrid.NombreRegimen,
                RegimenIntelisis: editarGrid.RegimenIntelisis,
                CodigosResponsabilidades: editarGrid.CodigosResponsabilidades,
                Autoretenedor: editarGrid.Autoretenedor ?? false,
                RetenedorIVA: editarGrid.RetenedorIVA ?? false,
                Usuario: user.Usuario,
                Estatus: editarGrid.Estatus
            };
    
            const config = {
                method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${user.Token}`
                    },
                    body: JSON.stringify(data)
            };
    
            await enviarPeticion(config, CONFIGURAR.ActualizarRegimen);
            await llenarLista();
            setShowModalEditar(false);

            if (tituloModal === 'Agregar Configuración'){
                setAlert({ msg: 'Se ha registrado el régimen', severity: 'success', open: true });
            }
            else{
                setAlert({ msg: 'Se ha actualizado el régimen', severity: 'success', open: true });
            }
            
        }
    }

    const agregarRegimen = async (event) => {
        setTituloModal('Agregar Configuración');

        setSeleccionado({});
        setEditarGrid({Estatus: 'Activo'});
        setShowModalEditar(true);
        // event.preventDefault();

        // //VALIDMAOS LO QUE ESCRIBIERON
        // if (nuevoRegimen === null || nuevoRegimen === undefined || nuevoRegimen === "" || nuevoRegimen.length > 3){
        //     await registrarRegimen();
        //     await llenarLista();
        //     setNuevoRegimen('');

        //     setAlert({ msg: 'Nuevo Régimen Agregado', severity: 'success', open: true });
        // }
        // else{
        //     setAlert({ msg: 'Escribe un Nombre de Régimen Válido', severity: 'warning', open: true });
        // }
    }


    const llenarLista = async () => {

        const data = {
            Estatus: "0"
        };

        const config = {
            method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.Token}`
                },
                body: JSON.stringify(data)
        };

        const res = await enviarPeticion(config, CONFIGURAR.ListaRegimenes);
        setListaRegimenes(res.data);
    }

    const llenarRegimenesIntelisis = async () => {

        const config = {
            method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.Token}`
                }
        };

        const res = await enviarPeticion(config, CONFIGURAR.ListaRegimenesIntelisis);
        const nuevo = {value: "Selecciona una opción"};
        const nuevoRes = [nuevo, ...res.data];

        setListaRegimenesIntelisis(nuevoRes);
    }
    
    // const registrarRegimen = async () => {
    //     const data = {
    //         NuevoRegimen: nuevoRegimen,
    //         Usuario: user.Usuario
    //     }

    //     const config = {
    //         method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': `Bearer ${user.Token}`
    //             },
    //             body: JSON.stringify(data)
    //     };

    //     await enviarPeticion(config, CONFIGURAR.NuevoRegimen);
    // }

    const quitarRegimen = async () => {

        const data = {
            IdConfiguracion: seleccionado.IdConfiguracion,
            Usuario: user.Usuario
        };

        const config = {
            method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.Token}`
                },
                body: JSON.stringify(data)
        };

        await enviarPeticion(config, CONFIGURAR.QuitarRegimen);
        await llenarLista();
        setShowModalEliminar(false);
        setAlert({ msg: 'Se ha eliminado el régimen', severity: 'success', open: true });
    }

    useEffect(() => {
        const inicio = async () => {
            await llenarLista();
            await llenarRegimenesIntelisis();
            setLoading(false);
        }

        //VALIDAMOS LA SESIÓN
        if (user.Usuario === '' || user.Usuario === null || user.Usuario === undefined){
            history.push(APP.INDEX);
        }
        else{
            inicio();
        }

        return (() => {
            //console.log("");
        });

    },[]);

     return (<>
     <Helmet>
        <title>Configurar Regímenes</title>
     </Helmet>

     {
        loading ?
        <div className={'container'}>
            <div style={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <CircularProgress size={100} thickness={2}></CircularProgress>
            </div>
        </div>
        :
        <div className={'container'}>
            <div className="fontNewsGothic">
                <div className="col-sm-12 col-md-12 col-lg-12">

                    {
                        alert.open ? <Alert msg={alert.msg} open={alert.open} severity={alert.severity} segundos={alert.segundos ? alert.segundos : 6} closeAlert={closeAlert}/> : <></>
                    }

                    {/* INICIO MODAL ELIMINAR*/}
                    <ModalCS show={showModalEliminar} size='md' title='Eliminar Configuración' body={
                        <div>
                            <div className="col-sm-12 col-md-12 col-lg-12">     
                                <div className="col-sm-12 col-md-12 col-lg-12 contenedorModal">                        
                                    <LabelCS label='¿Deseas eliminar la configuración?'></LabelCS>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-12 col-lg-12">   
                                <div className="col-sm-12 col-md-12 col-lg-12 contenedorModal">      
                                    <LabelCS style={{fontWeight: 'bold'}} label={seleccionado.NombreRegimen}></LabelCS>
                                </div>                        
                                
                            </div>

                            <div className="col-sm-12 col-md-12 col-lg-12 contenedorModal">     
                                <div className="col-sm-6 col-md-6 col-lg-6" style={{textAlign: '-webkit-center'}}>                        
                                    <BotonCS title="Eliminar" handleSubmit={quitarRegimen}></BotonCS>
                                </div>
                                <div className="col-sm-6 col-md-6 col-lg-6"style={{textAlign: '-webkit-center'}}>                             
                                    <BotonCS color="#7F7F7F" title="Regresar" handleSubmit={cerrarModalEliminar}></BotonCS>
                                </div>
                            </div>

                        </div>
                    }></ModalCS>
                    {/* FIN MODAL ELIMINAR*/}

                    {/* INICIO MODAL EDITAR */}
                    <ModalCS show={showModalEditar} size='md' title={tituloModal} body={
                        <div>
                            <br />

                            <div className="col-sm-12 col-md-12 col-lg-12">   
                                <div className="col-sm-12 col-md-12 col-lg-12 contenedorModal">      
                                    <LabelCS style={{fontWeight: 'bold'}} label="Nombre Régimen"></LabelCS>
                                </div>                   
                                <div className="col-sm-12 col-md-12 col-lg-12 contenedorModal">      
                                    <TextFieldCS value={editarGrid.NombreRegimen ?? ''} onChange={handleEdit("NombreRegimen")}></TextFieldCS>
                                </div>  
                            </div>
                            <br />

                            <div className="col-sm-12 col-md-12 col-lg-12">   
                                <div className="col-sm-12 col-md-12 col-lg-12 contenedorModal">      
                                    <LabelCS style={{fontWeight: 'bold'}} label="Régimen Intelisis"></LabelCS>
                                </div>                   
                                <div className="col-sm-12 col-md-12 col-lg-12 contenedorModal">     
                                    <DropDownListCS items={listaRegimenesIntelisis} default={editarGrid.RegimenIntelisis ?? ''} onChange={handleEdit("RegimenIntelisis")}></DropDownListCS> 
                                </div>  
                            </div>
                            <br />

                            <div className="col-sm-12 col-md-12 col-lg-12">   
                                <div className="col-sm-12 col-md-12 col-lg-12 contenedorModal">      
                                    <LabelCS style={{fontWeight: 'bold'}} label="Códigos Responsabilidades"></LabelCS>
                                </div>                   
                                <div className="col-sm-12 col-md-12 col-lg-12 contenedorModal">      
                                    <TextFieldCS value={editarGrid.CodigosResponsabilidades ?? ''} onChange={handleEdit("CodigosResponsabilidades")} onBlur={formatoCodigos}></TextFieldCS>
                                </div>  
                            </div>
                            <br />

                            <div className="col-sm-12 col-md-12 col-lg-12">   
                                <div className="col-sm-6 col-md-6 col-lg-6 contenedorModal">      
                                    <LabelCS style={{fontWeight: 'bold'}} label="Autoretenedor"></LabelCS>
                                </div>     
                                <div className="col-sm-6 col-md-6 col-lg-6 contenedorModal">         
                                    <LabelCS style={{fontWeight: 'bold'}} label="Retenedor IVA"></LabelCS>
                                </div>                
                                <div className="col-sm-6 col-md-6 col-lg-6 contenedorModal">         
                                    <input type='checkbox' checked={editarGrid.Autoretenedor ?? ''} onChange={handleEdit("Autoretenedor")} />
                                </div>  
                                <div className="col-sm-6 col-md-6 col-lg-6 contenedorModal">         
                                    <input type='checkbox' checked={editarGrid.RetenedorIVA ?? ''} onChange={handleEdit("RetenedorIVA")} />
                                </div>  
                            </div>
                            <br />

                            <div className="col-sm-12 col-md-12 col-lg-12">   
                                <div className="col-sm-12 col-md-12 col-lg-12 contenedorModal">      
                                    <LabelCS style={{fontWeight: 'bold'}} label="Estatus"></LabelCS>
                                </div>                   
                                <div className="col-sm-12 col-md-12 col-lg-12 contenedorModal">      
                                    <DropDownListCS items={[{value: 'Selecciona una opción'}, {value: 'Activo'}, {value: 'Inactivo'}]} default={editarGrid.Estatus} onChange={handleEdit("Estatus")}></DropDownListCS>
                                </div>  
                            </div>
                            <br />

                            <div className="col-sm-12 col-md-12 col-lg-12 contenedorModal">     
                                <div className="col-sm-6 col-md-6 col-lg-6" style={{textAlign: '-webkit-center'}}>                        
                                    <BotonCS title={tituloModal === 'Agregar Configuración' ? 'Agregar' : 'Actualizar'} handleSubmit={actualizarRegimen}></BotonCS>
                                </div>
                                <div className="col-sm-6 col-md-6 col-lg-6"style={{textAlign: '-webkit-center'}}>                             
                                    <BotonCS color="#7F7F7F" title="Regresar" handleSubmit={cerrarModalEditar}></BotonCS>
                                </div>
                            </div>

                        </div>
                    }></ModalCS>
                    {/* FIN MODAL EDITAR */}

                    

                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <label className='tituloSeccion'>Configurar Nuevo Régimen</label>
                    </div>
                    <br />
                    <br />
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <BotonCS title="Agregar Nuevo Régimen" handleSubmit={agregarRegimen}></BotonCS>
                        </div>
                        
                    </div>
                    <br />
                    <br />
                    <br />
                    <br />

                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <label className='tituloSeccion'>Catálogo de Regímenes</label>
                    </div>
                    <br />
                    <br />

                    <TableCS
                        columns={columnasTabla}
                        data={listaRegimenes}
                    />
                    <br />
                    <br />
                    <br />
                    <br />                    

                </div>
            </div>
        </div>

     }
     </>)
}

export default React.memo(withRouter(ConfigurarRegimenes));